
























































































import { Component, Vue } from "vue-property-decorator";
import { RequestsModule } from "@/store/requests.module";
import { translate } from "@/utils";
import { Attachment } from "~/requests.type";
import { FileService } from "@/services/file.service";

@Component({})
export default class Attachments extends Vue {
  clickFile(index: number) {
    const x = this.$refs["file_" + index] as any;
    x.$refs.input.click();
  }
  expanded = [];
  protected formRef = "formAttachments";
  ReadOnly: boolean = false;
  reload: boolean = false;

  get attachmentList() {
    const r = RequestsModule.attachmentList;
    const attach_docestate = r.find((a) => a.code_name === "attach_docestate");
    const attach_docestate_other = r.find(
      (a) => a.code_name === "attach_docestate_other",
    );
    if (attach_docestate_other) attach_docestate_other.is_required = true;
    if (attach_docestate) attach_docestate.is_required = true;
    if (
      attach_docestate &&
      attach_docestate.attach_file_name &&
      attach_docestate_other
    ) {
      attach_docestate_other.is_required = false;
    }
    if (
      attach_docestate_other &&
      attach_docestate_other.attach_file_name &&
      attach_docestate
    ) {
      attach_docestate.is_required = false;
    }
    return translate(r);
  }

  get headers() {
    const head = [
      {
        text: this.$t("requests.attach_type_name"),
        value: "attach_type_name",
        sortable: false,
      },
      {
        text: this.$t("requests.attach_file_name"),
        value: "attach_file_name",
        sortable: false,
        width: "15%",
      },
    ];
    if (!this.ReadOnly)
      head.push({
        text: this.$t("requests.action"),
        value: "action",
        sortable: false,
        width: "10%",
      });
    return head;
  }

  async showFile(item: Attachment) {
    await RequestsModule.getFile(item.attach_id).then((res) => {
      const byteOffset = 0;
      const b = new Blob([
        new Uint8Array(res.attach_file.data, byteOffset, length),
      ]);
      FileService.downloadFile(b, item.attach_file_name);
    });
  }

  get enableNextStep() {
    return (this.reload || !this.reload) &&
      this.attachmentList &&
      this.attachmentList.length > 0 &&
      this.attachmentList.filter((item) => item.is_required).length ===
        this.attachmentList.filter(
          (item) => item.is_required && item.attach_file_name,
        ).length
      ? true
      : false;
  }

  async deleteFile(item: Attachment) {
    await RequestsModule.deleteAttachment(item.attach_id).then((res) => {
      item.fileData = null as any;
      item.attach_file_name = null as any;
      item.attach_file_type = null as any;
      this.reload = !this.reload;
      this.ReloadTable();
    });
  }

  async fileChange(item: Attachment) {
    if (item.fileData) {
      const f = item.fileData;

      //проверим файл на размер
      const ext = f.name
        .substring(f.name.lastIndexOf(".") + 1, f.name.length)
        .toLowerCase();
      const exts = ["png", "jpg", "jpeg", "gif", "pdf"];
      if (exts.indexOf(ext) < 0 || f.size > 28 * 1024 * 1024) {
        item.fileData = null as any;
        item.attach_file_name = null as any;
        item.attach_file_type = null as any;
        return;
      }

      const formData = new FormData();
      formData.append("file", item.fileData);
      await RequestsModule.uploadFile({
        attatchment_type_rid: item.attatchment_type_rid,
        RID: Number.parseInt(this.$route.params.id),
        data: formData,
      }).then(() => {
        item.attach_file_name = item.fileData.name;
        item.attach_file_type = item.fileData.type;
        this.ReloadTable();
      });
    }
  }

  showOldPage() {
    this.$router.push("/newcontract/" + this.$route.params.id);
  }

  ValidateAndSave() {
    this.$router.push("/plan/" + this.$route.params.id);
  }

  validateForm() {
    return (
      this.$refs[this.formRef] as Vue & {
        validate: () => boolean;
      }
    ).validate();
  }

  async ReloadTable() {
    const id = this.$route.params.id;
    if (!id) this.$router.push("/contracts");
    else {
      this.ReadOnly =
        RequestsModule.SelectedItem && !RequestsModule.SelectedItem.can_attach;
    }
    await RequestsModule.getAttachments(Number.parseInt(id));
  }

  async mounted() {
    RequestsModule.setAttacList([]);
    this.ReloadTable();
  }

  get rules() {
    return {
      required: (value: string) => {
        return typeof value === "boolean" || typeof value === "number"
          ? true
          : !!value || this.$t("form-validator.required");
      },
      fileSize: (f: File) => {
        if (f) {
          const ext = f.name
            .substring(f.name.lastIndexOf(".") + 1, f.name.length)
            .toLowerCase();
          const exts = ["png", "jpg", "jpeg", "gif", "pdf"];
          if (exts.indexOf(ext) < 0) {
            return this.$t("action-send-count.file_ext_error");
          } else if (f.size > 28 * 1024 * 1024) {
            return this.$t("action-send-count.file_size_error");
          } else return true;
        } else return true;
      },
    };
  }
}
